<template>
    <transition name="modal-fade">
        <div class="modal__backdrop" @click="close">
            <div @click.stop class="modal__container" :class="{ 'modal__container--card': isCard === true }">
                <div class="modal__inner" :class="{ 'modal__inner--narrow': narrow === true }">
                    <span v-if="hasCloseButton" @click="close" class="modal__close-icon">&#10006;</span>
                    <header class="modal__header">
                        <slot name="header"></slot>
                    </header>

                    <div class="modal__body">
                        <slot name="body"></slot>
                    </div>

                    <footer class="modal__footer">
                        <slot name="footer"></slot>
                    </footer>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isCard: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDismissedOnClickBackdrop: {
            type: Boolean,
            required: false,
            default: true,
        },
        hasCloseButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        narrow: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        close: function () {
            if (this.isDismissedOnClickBackdrop === true) {
                this.$emit("close");
            }
        },
    },
};
</script>
